import { CalendarMonthOutlined } from '@mui/icons-material'
import { Button, Dialog } from '@mui/material'
import { useEffect, useState } from 'react'

function MonthAndYearPicker({onChange, value}) {
    const [years, setYears] = useState([])

    const months = ["January", "Feberuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

    const [selectionPanel, setSelectionPanel] = useState(0)
    const [selectedMonth, setSelectedMonth] = useState(value.month)
    const[selectedYear, setSelectedYear] = useState(value.year)
    useEffect(()=>{
        let refYear = new Date().getFullYear()
        let tempYears= []
        for(let i = 2010 ; i <= refYear + 4 ;  i++){
            tempYears.push(i)
        }
        setYears(tempYears)
    },[])

    useEffect(()=>{
        onChange && onChange({month : selectedMonth, year : selectedYear})
    },[selectedMonth, selectedYear])

    const handleYearChange = (year) =>{
        setSelectedYear(year)
    }

    const handleMonthChange = (monthIndex) =>{
        setSelectedMonth(monthIndex)
        handleDateDialog()
    }

    const [isDateSelectorOpen, setDateSelectorOpen] = useState(false)

  const handleDateDialog = () =>{
    setDateSelectorOpen(!isDateSelectorOpen)
  }

    

  return (
   <>
    <Button
        endIcon={<CalendarMonthOutlined />}
     onClick={handleDateDialog}
    >
        {months[selectedMonth].substring(0,3)} - {selectedYear}
    </Button>
    <Dialog
    open={isDateSelectorOpen}
    onClose={handleDateDialog}
  >
    <div className='p-3 text-center'><h4 >Select {selectionPanel=== 0 ? "Year" : "Month"}</h4>
    <h6>{selectedYear} - {months[selectedMonth]}</h6>
        <div
        className='d-flex flex-wrap justify-content-evenly'
        style={{
            padding:"2%",
            width:"100%",
        }}>
            
            {
             selectionPanel === 0 &&  years.map(year=> <Button
                key={year}
                style={{
                    borderRadius:"50px",
                    margin:"2%"
                }}
                variant={year === selectedYear ? "contained" : "outlined"}
                onClick={()=>{
                    handleYearChange(year)
                    setSelectionPanel(1)
                }}
                disabled={year > new Date().getFullYear()}
               >
                    {year}
                </Button>
                )
            }

            {
                selectionPanel === 1 && months.map((month, x)=>(
                    <Button
                    key={x}
                    style={{
                        borderRadius:"50px",
                        margin:"2%"
                    }}
                    variant={x === selectedMonth && !(selectedYear >= new Date().getFullYear() && x > new Date().getMonth()) ? "contained" : "outlined"}
                    onClick={()=>{
                        handleMonthChange(x)
                        setSelectionPanel(0)
                    }}
                    disabled={selectedYear >= new Date().getFullYear() && x > new Date().getMonth()}
                   >
                        {month}
                    </Button>
                ))
            }
        </div>
    </div>
    </Dialog>
    </>
  )
}

export default MonthAndYearPicker